module.exports = __webpack_public_path__ + "static/couple-happy-bowls-square.e2fda4f1.jpg";